import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import Walletsidebar from "../../../components/Wallet_sidebar";
import { images } from "../../../constants/index";
import Investmodal from "./Invest_modal";
const InvestForm = () => {
  const [amount, setAmount] = useState("");
  const [agree, setAgree] = useState(false);
 const [purchase, setPurchase] = useState(false);
  const handleInvest = () => {
    if (!agree) {
      alert("Please agree to the terms and conditions.");
      return;
    }
    if (amount < 100) {
      alert("Minimum investment is $100.");
      return;
    }
    // Handle invest logic
    alert(`Invested $${amount}`);
  };

  return (
    <Row>
      <Investmodal purchase={purchase} setPurchase={setPurchase} />
      <div className="screenHeight d-flex justify-content-around align-items-center p-3">
        <Col
          lg="3"
          xl="2"
          sm="4"
          xs="4"
          className="bg-white shadow-sm h-100 rounded"
          style={{ border: "1px solid #0353a4" }}
        >
          <Walletsidebar />
        </Col>

        <Col
          lg={8}
          md={8}
          sm={8}
          className="p-5 shadow rounded"
          style={{ backgroundColor: "#f8fbff" }}
        >
          <h3 className="fw-bold">Invest in Our Company</h3>
          <p className="text-muted">
            Invest with us and enjoy competitive returns with the flexibility to
            withdraw your funds at any time.
          </p>
          <div className="mb-4">
            <strong>Wallet Balance</strong>
            <h4 className="text-success mt-1">$12,500</h4>
          </div>

          <Card className="p-4">
            <h5 className="mb-3 fw-semibold">Investment Form</h5>
            <div className="d-flex justify-content-left walletezilogo">
              <img
                variant="top"
                src={images.Wallet1}
                alt="Selectezi"
                className="mb-3"
                style={{ maxHeight: "200px", objectFit: "contain" }}
              />
            </div>
            <p>
              <strong>Investment Details</strong>
              <br />
              <p className="text-muted">
                Enter the amount you wish to invest. <br></br> The minimum
                investment is $100.
              </p>
            </p>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Investment Amount</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <Form.Text className="text-muted">
                  Minimum investment: $100
                </Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="I agree to the terms and conditions"
                  checked={agree}
                  onChange={(e) => setAgree(e.target.checked)}
                />
              </Form.Group>

              <Button
                variant="primary"
                onClick={()=>setPurchase(true)}
                disabled={!agree}
              >
                Invest Now
              </Button>
            </Form>
          </Card>
        </Col>
      </div>
    </Row>
  );
};

export default InvestForm;
